import iconBloomfilter from '../../../assets/icons/iconBloomfilter.svg';
import { icons } from '../../../assets/icons/icons';
import iconADO from './iconADO.svg';
import iconJiraCloud from './iconJiraCloud.svg';
import iconJiraDataCenter from './iconJiraDataCenter.svg';
import iconLinear from './iconLinear.svg';

const iconGithub = icons.iconGithub;
const iconFigma = icons.iconFigma;

export const iconsIntegrations = {
  iconADO,
  iconJiraCloud,
  iconJiraDataCenter,
  iconGithub,
  iconFigma,
  iconBloomfilter,
  iconLinear,
};
